import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { SharedService } from 'src/app/shared/services/shared.service'
import { Location } from '@angular/common'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'
import { MatDialog } from '@angular/material/dialog'
import { AuthService } from 'src/app/modules/auth/services/auth.service'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
	@Output() toggleNav = new EventEmitter()
	fullName = JSON.parse(localStorage.getItem('fullName') || '')
	profileImageUrl: any =
		environment.attachmentPath +
		JSON.parse(localStorage.getItem('profileImageUrl') || '')
	title = ''
	breadCrumbObject: any
	breadCrumb: any[] = []
	constructor(
		private sharedService: SharedService,
		private location: Location,
		private router: Router,
		public authServ: AuthService,
		private dialog: MatDialog
	) {
		sharedService.headerTitle.subscribe((res) => {
			this.title = res
		})
		// let currentRouter = router.url.split('?')[0].split('/')
		// !isNaN(+currentRouter[currentRouter?.length-1]) ? currentRouter = currentRouter.splice(0,currentRouter?.length-2) : null
		sharedService.breadCrumbRout.subscribe((res: any) => {
			this.breadCrumb = []
			this.breadCrumbObject = res
			Object.entries(res).forEach((res) => {
				this.breadCrumb.push(res)
			})
		})
	}

	ngOnInit(): void {}

	onclickLink(i: number, path: any) {
		Object.keys(this.breadCrumbObject).forEach((key, index) =>
			index > i ? delete this.breadCrumbObject[key] : null
		)
		this.sharedService.breadCrumbRout.next(this.breadCrumbObject)
		this.router.navigate(
			[path[1]?.id ? path[1]?.url + '/' + path[1]?.id : path[1]?.url],
			{ queryParams: path[1]?.queryParams }
		)
	}

	goToBack() {
		Object.keys(this.breadCrumbObject).forEach((key, index) =>
			index == this.breadCrumb?.length - 1
				? delete this.breadCrumbObject[key]
				: null
		)
		this.sharedService.breadCrumbRout.next(this.breadCrumbObject)
		this.location.back()
	}

	viewProfile() {
		let userId = localStorage.getItem('userId')
		this.router.navigateByUrl(`/layout/users/profile/${userId}`)
	}
	openDialog() {
		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '385px',
				// height: '340px',
				data: {
					notflex: true,
					image: 'assets/images/logout_big.svg',
					message: 'CONFIRMATION_MESSAGE.LOGOUT',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: 'ACTIONS.SIGNOUT',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					res ? this.authServ.logOut() : null
				},
			})
	}
}
